// components/MiniDoughnutChart.jsx
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
ChartJS.register(ArcElement, Tooltip);

export default function MiniDoughnutChart({ valor, total, cor, label }) {
    const percentual = total > 0 ? (valor / total) * 100 : 0;

    const data = {
        datasets: [
            {
                data: [valor, total - valor],
                backgroundColor: [cor, '#e0e0e0'],
                borderWidth: 0,
            },
        ],
    };

    const options = {
        cutout: '75%',
        plugins: {
            tooltip: { enabled: false },
        },
    };

    return (
        <div style={{ position: 'relative', width: 120, height: 120 }}>
            <Doughnut data={data} options={options} />
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: 18,
                fontWeight: 'bold',
                textAlign: 'center',
            }}>
                {percentual.toFixed(2)}%
            </div>
        </div>
    );
}